import React from "react";

const QuoteOpen = () => {
  return (
    <svg fill="none" viewBox="0 0 42 36">
      <path fill="#002221" d="M17.5848.849121V7.37455C10.4637 8.8576 7.12111 15.2347 7.12111 20.4254c0 .2966.14533.5932.14533.8898.87197-.4449 2.17993-.7415 3.19726-.7415 4.6505 0 7.2664 2.8178 7.2664 7.5636 0 5.0423-3.3426 7.7118-7.7024 7.7118C3.48789 35.8491 0 29.6203 0 22.65 0 13.6034 4.0692 3.37031 17.5848.849121Zm24.1245 0V7.37455C34.7336 8.8576 31.391 15.2347 31.391 20.4254v.8898c1.0173-.4449 2.1799-.7415 3.3426-.7415 4.6505 0 7.2664 2.8178 7.2664 7.5636 0 5.0423-3.3426 7.7118-7.7024 7.7118-6.5398 0-10.0277-6.2288-10.0277-13.1991 0-9.0466 4.0692-19.27969 17.4394-21.800879Z"/>
    </svg>
  )
}

export default QuoteOpen